import { Injectable, inject } from '@angular/core';
import { NzDrawerService } from 'ng-zorro-antd/drawer';
import { OperationDetailOpener } from '@beautyapp/core';
import { OperationDetailComponent } from '../components/operation-detail/operation-detail.component';

/**
 * Concrete OperationDetailOpener. Mirrors operations.component.ts:view(row):
 * opens OperationDetailComponent in a drawer keyed by operationId.
 */
@Injectable()
export class OperationDetailDrawerOpener implements OperationDetailOpener {
  private readonly drawerService = inject(NzDrawerService);

  open(operationId: number): void {
    this.drawerService.create<OperationDetailComponent, { operationId: number }, string>({
      nzTitle: `# ${operationId}`,
      nzContent: OperationDetailComponent,
      nzWrapClassName: 'user-drawer',
      nzBodyStyle: { padding: '0 15px 15px 15px' },
      nzData: { operationId },
    });
  }
}
